import { useMsal } from '@azure/msal-react';
import { useQueryClient } from '@tanstack/react-query';
import { SessionExpiredDialog } from '../components';
import { getApiScopes } from './msalConfig';
import { clearSessionExpired, useAuthStatus } from './authStatus';
import { whoamiQueryKey } from '../api/whoami';

/**
 * App-level host that binds the session-expired signal to the re-auth
 * interstitial. Mounted once (in `App`) so the dialog can overlay the shell on a
 * mid-session renewal failure, and the neutral "signing you in" backdrop on a
 * bootstrap renewal failure. "Sign in" clears the flag, drops the stale
 * `['whoami']` cache, and re-initiates `loginRedirect`.
 */
export function SessionExpiredHost() {
  const { instance } = useMsal();
  const queryClient = useQueryClient();
  const { sessionExpired } = useAuthStatus();

  const handleSignIn = () => {
    clearSessionExpired();
    queryClient.removeQueries({ queryKey: whoamiQueryKey });
    void instance.loginRedirect({ scopes: getApiScopes() });
  };

  return <SessionExpiredDialog open={sessionExpired} onSignIn={handleSignIn} />;
}
